module.exports = __webpack_public_path__ + "7577ae6f57358bf586dcf4108b9e3473.ttf";